import { IResponse } from '@/types';
import { request } from './request';

const VERIFY_BUSINESS_NUMBER = 'signup/verify/businessnumber';
const SUBMIT_SIGNUP = 'signup/account';
const SUBMIT_INTEREST = 'signup/interest';
const VERIFY_INTEREST_EXIST = 'signup/verify/exist_interest';
const VERIFY_SIGNUP_EXIST = 'signup/verify/exist_signup';

export const verifyBusinessNumberApi = async (
  bizNo: string
): Promise<IResponse<string>> => {
  try {
    const response = await request.get(VERIFY_BUSINESS_NUMBER, {
      params: {
        bizNo
      }
    });
    return {
      isSuccess: true,
      data: response?.data.data
    };
  } catch (error: any) {
    return {
      isSuccess: false,
      code: error?.code,
      message: error?.message
    };
  }
};

export const signupApi = async (data: any) => {
  try {
    const response = await request.post(SUBMIT_SIGNUP, data);
    return {
      isSuccess: true,
      data: response?.data
    };
  } catch (error: any) {
    return {
      isSuccess: false,
      code: error?.response?.data?.code,
      message: error?.response?.data?.message
    };
  }
};

export const verifyInterestExist = async (data: any) => {
  try {
    const token = btoa(data.email);
    const response = await request.get(VERIFY_INTEREST_EXIST, {
      params: { token }
    });
    return {
      isSuccess: true,
      data: response?.data.data
    };
  } catch (error: any) {
    return {
      isSuccess: false,
      code: error?.response?.data?.code,
      message: error?.response?.data?.message
    };
  }
};

export const verifyExistSignup = async (data: { email: string }) => {
  try {
    const token = btoa(data.email);
    const response = await request.get(VERIFY_SIGNUP_EXIST, {
      params: { token }
    });
    return {
      isSuccess: true,
      data: response?.data.data
    };
  } catch (error: any) {
    return {
      isSuccess: false,
      code: error?.response?.data?.code,
      message: error?.response?.data?.message
    };
  }
};

export const interestSubmitApi = async (
  data: any
): Promise<IResponse<string>> => {
  try {
    const response = await request.post(SUBMIT_INTEREST, data);
    return {
      isSuccess: true,
      data: response?.data.data
    };
  } catch (error: any) {
    return {
      isSuccess: false,
      code: error?.response?.data?.code,
      message: error?.response?.data?.message
    };
  }
};
